import React from 'react'
import styled from 'styled-components'
import img from '../assets/testimonial.jpg'

const Wrapper = styled.div`
    display: inline-block;
    width: 50%;
    align-items: center;
    white-space: normal;
    padding: 15px;
    .perfil {
        display: flex;
        gap: 12px;
        align-items: center;
        .img {
            border-radius: 50%;
            width: 75px;
            height: 75px;
        }
        .infos {
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
    }
    .comment {
        margin-top: 16px;
        white-space: normal;
    }
    
    @media (max-width: 800px) {
        width 100%;
    }
`

function Card() {
  return (
      <Wrapper>
            <div className='perfil'>
                <img className='img' alt='testimonial' src={img} />
                <div className='infos'>
                    <p className='name'>Nome</p>
                    <p className='instagram'>@nome</p>
                </div>
            </div>
            <p className='comment'>Excelente profissional. Foi exatamente o que eu precisava. Continuarei com ela administrando minhas redes sociais.</p>
      </Wrapper>
  );
}

export default Card;